import { configSingleStory } from "@pub/config";
import { PromoBox, Typography } from "@sphtech/dmg-design-system";
import { PropsWithChildren, ReactNode } from "react";

import { ResolvedCUEElement } from "../elements";
import { Annotation } from "./Annotation/Annotation";

type PromoBoxElementProps = {
  element: ResolvedCUEElement;
};

export type PromoBoxVariantProps = PropsWithChildren<{
  label?: string;
  title?: string;
  ctaLabel?: string;
  ctaUrl?: string;
}>;

export default function PromoBoxElement({
  element,
}: PromoBoxElementProps): ReactNode {
  const promoBoxInfo = element.children?.find(
    (el) => el.type === "promo_box_info",
  )?.additionalFields;

  const variantKey = promoBoxInfo?.promoBoxLabelName?.value
    ?.trim()
    .toLowerCase();
  const variant = variantKey
    ? Object.entries(configSingleStory.promoBox?.variants ?? {}).find(
        ([key]) => key.trim().toLowerCase() === variantKey,
      )?.[1]
    : undefined;

  const Component: (props: PromoBoxVariantProps) => ReactNode =
    variant ?? PromoBox;

  return (
    <Component
      label={promoBoxInfo?.promoBoxLabelName?.value}
      title={promoBoxInfo?.promoBoxHeading?.value}
      ctaLabel={promoBoxInfo?.ctaLabel?.value}
      ctaUrl={promoBoxInfo?.ctaURL?.value}
    >
      {element.children
        ?.filter((el) => el.type === "paragraph")
        .map((element, index) => (
          <Typography.Body key={index}>
            <Annotation element={element} />
          </Typography.Body>
        ))}
    </Component>
  );
}
